export default {"src":"/_next/static/media/shirt-sport.e7e849a9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};